/**
 * QUIEN CIERRA UNA MISION Y QUIEN PAGA (SEC-ESCRITURAS-ANONIMAS-T1, quinta puerta, D-89 a; nexo-api PR 435).
 *
 * DE DONDE SALE. Antes el panel, al pasar una mision a completed, creaba UNA transaccion NXS por cada agente de
 * [AGENTE: ...] y otra para el usuario de la sesion, con .catch vacio: si fallaban, nadie se enteraba, y si se
 * repetian, se pagaba dos veces (3 pares duplicados medidos por A). Desde el 435 la API paga al cerrar, una vez por
 * persona, y solo el admin cierra: un no admin recibe 403 SOLO_ADMIN_CIERRA.
 *
 * LA REGLA:
 *   - el panel NO escribe NXS: pide el cambio de estado y la API paga
 *   - 403 al cerrar = SOLO_ADMIN_CIERRA: se DICE (la tarea quedo hecha; la mision la cierra un administrador)
 *   - 409 = ya estaba cerrada: no es error ni se vuelve a pagar
 *   - el motivo sale del codigo HTTP (res.code), no del texto, que ApiBase traduce
 *
 * Sin DOM: lo prueba scripts/check-cierre-sin-pago.mjs.
 */

/** Lo que paso al pedir status completed. Nunca lanza. */
export function leerCierre(res) {
  if (res?.ok) return { cerrada: true, motivo: 'CERRADA', frase: 'Mision cerrada: la API paga los NXS a los participantes.' };
  const codigo = Number(res?.code ?? res?.details?.status);
  if (codigo === 403) {
    return { cerrada: false, motivo: 'SOLO_ADMIN_CIERRA', frase: 'La tarea quedo completada, pero la mision la cierra un administrador: cerrarla paga NXS.' };
  }
  if (codigo === 409) return { cerrada: false, motivo: 'YA_CERRADA', frase: 'La mision ya estaba cerrada.' };
  return { cerrada: false, motivo: 'ERROR', frase: 'No se pudo cerrar la mision ahora; la tarea si quedo completada.' };
}
